import { Component } from '@theme/component';

/**
 * @typedef {object} Refs
 * @property {HTMLSelectElement} select
 */

/** @extends Component<Refs> */
class ViewToggleComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const current = document.documentElement.dataset.productView || 'product';
    this.refs.select.value = current;
  }

  /** @param {Event} event */
  handleChange(event) {
    const select = /** @type {HTMLSelectElement} */ (event.target);
    const mode = select.value;

    try { localStorage.setItem('product-view-mode', mode); } catch {}
    document.documentElement.dataset.productView = mode;
  }
}

if (!customElements.get('view-toggle')) {
  customElements.define('view-toggle', ViewToggleComponent);
}
